import React, { useState, useEffect } from 'react';
import Header from '../../components/admin/Header';
import Sidebar from '../../components/admin/Sidebar';
import Footer from '../../components/admin/Footer';
import { 
  Save,
  X,
  Upload,
  ChevronDown,
  ChevronUp,
  Globe,
  Shield,
  Users,
  FileText,
  PieChart,
  BarChart3,
  Award,
  Phone,
  Mail,
  MapPin,
  Youtube,
  Instagram,
  ExternalLink
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'react-toastify';

const ContentManagement = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contentData, setContentData] = useState({
    // HERO SECTION
    hero_title: '',
    hero_subtitle: '',
    hero_button_text1: '',
    hero_button_link1: '',
    hero_button_text2: '',
    hero_button_link2: '',
    hero_card1_title: '',
    hero_card1_text: '',
    hero_card2_title: '',
    hero_card2_text: '',
    hero_card3_title: '',
    hero_card3_text: '',

    // PMP SECTION
    pmp_card1_text: '',
    pmp_card2_text: '',
    pmp_card3_text: '',
    pmp_card4_text: '',
    pmp_left_card_title: '',
    pmp_left_card_desc: '',
    pmp_left_card_info: '',
    pmp_left_card_text1: '',
    pmp_left_card_text2: '',
    pmp_left_card_text3: '',
    pmp_left_card_text4: '',
    pmp_left_card_text5: '',
    pmp_right_card1_title: '',
    pmp_right_card1_info: '',
    pmp_right_card2_title: '',
    pmp_right_card2_info: '',
    pmp_right_card3_title: '',
    pmp_right_card3_info: '',
    pmp_right_card4_title: '',
    pmp_right_card4_info: '',
    pmp_importent_note_text: '',
    why_choose_num1: '',
    why_choose_text1: '',
    why_choose_num2: '',
    why_choose_text2: '',
    why_choose_num3: '',
    why_choose_text3: '',

    // SAP SECTION
    sap_left_card_title_main: '',
    sap_left_card_title1: '',
    sap_left_card_info1: '',
    sap_left_card_title2: '',
    sap_left_card_info2: '',
    sap_left_card_title3: '',
    sap_left_card_info3: '',

    // AMM SECTION
    amm_card1_title: '',
    amm_card1_text: '',
    amm_card2_title: '',
    amm_card2_text: '',
    amm_card3_title: '',
    amm_card3_text: '',
    amm_card4_title: '',
    amm_card4_text: '',
    amm_left_card_title: '',
    amm_our_mission_text: '',
    amm_left_card_rd_text1: '',
    amm_left_card_rd_text2: '',
    amm_left_card_rd_text3: '',
    amm_left_card_rd_text4: '',
    amm_left_card_rd_text5: '',
    amm_right_card_title: '',
    amm_right_card_text1: '',
    amm_right_card_text2: '',
    amm_right_card_text3: '',
    amm_right_card_text4: '',
    amm_right_card_text5: '',
    amm_right_card_dr_text1: '',
    amm_right_card_dr_link1: '',
    amm_right_card_dr_text2: '',
    amm_right_card_dr_link2: '',

    // MEMBER BENEFITS
    mb_card1_title: '',
    mb_card1_text1: '',
    mb_card1_text2: '',
    mb_card1_text3: '',
    mb_card1_text4: '',
    mb_card2_title: '',
    mb_card2_text1: '',
    mb_card2_text2: '',
    mb_card2_text3: '',
    mb_card2_text4: '',
    mb_card3_title: '',
    mb_card3_text1: '',
    mb_card3_text2: '',
    mb_card3_text3: '',
    mb_card3_text4: '',
    mb_card4_title: '',
    mb_card4_text1: '',
    mb_card4_text2: '',
    mb_card4_text3: '',
    mb_card4_text4: '',
    mb_card5_title: '',
    mb_card5_text1: '',
    mb_card5_text2: '',
    mb_card5_text3: '',
    mb_card5_text4: '',
    mb_card6_title: '',
    mb_card6_text1: '',
    mb_card6_text2: '',
    mb_card6_text3: '',
    mb_card6_text4: '',
    mb_pa_title: '',
    mb_pa_text1: '',
    mb_pa_text2: '',
    mb_pa_text3: '',
    mb_pa_info: '',

    // QUICK START
    qs_card1_title: '',
    qs_card1_text: '',
    qs_card2_title: '',
    qs_card2_text: '',
    qs_card3_title: '',
    qs_card3_text: '',
    qs_card4_title: '',
    qs_card4_text: '',
    qs_main_card1_title: '',
    qs_main_card1_info: '',
    qs_main_card1_text1: '',
    qs_main_card1_text2: '',
    qs_main_card1_text3: '',
    qs_main_card2_title: '',
    qs_main_card2_info: '',
    qs_main_card2_text1: '',
    qs_main_card2_text2: '',
    qs_main_card2_text3: '',
    qs_main_card3_title: '',
    qs_main_card3_info: '',
    qs_main_card3_text1: '',
    qs_main_card3_text2: '',
    qs_main_card3_text3: '',
    qs_main_card4_title: '',
    qs_main_card4_info: '',
    qs_main_card4_text1: '',
    qs_main_card4_text2: '',
    qs_main_card4_text3: '',

    // SECURITY MATTERS
    sm_card1_title: '',
    sm_card1_info: '',
    sm_card2_title: '',
    sm_card2_info: '',
    sm_card3_title: '',
    sm_card3_info: '',
    sm_card4_title: '',
    sm_card4_info: '',
    sm_pp_text1: '',
    sm_pp_text2: '',
    sm_pp_text3: '',
    sm_pp_text4: '',
    sm_is_text1: '',
    sm_is_text2: '',
    sm_is_text3: '',
    sm_is_text4: '',
    sm_256_bit_info: '',

    // REGULATORY COMPLIANCE
    ra_left_card_title_main: '',
    ra_left_card_info_main: '',
    ra_left_card_title1: '',
    ra_left_card_content1: '',
    ra_left_card_title2: '',
    ra_left_card_content2: '',
    ra_rd_title: '',
    ra_rd_info: '',
    ra_dr_title1: '',
    ra_dr_content1: '',
    ra_dr_title2: '',
    ra_dr_content2: '',
    ra_tag1: '',
    ra_tag2: '',
    ra_tag3: '',
    ra_tag4: '',

    // CONTACT SECTION
    contact_card1_title: '',
    contact_card1_info: '',
    contact_card1_value: '',
    contact_card1_content: '',
    contact_card2_title: '',
    contact_card2_info: '',
    contact_card2_value: '',
    contact_card2_content: '',
    contact_card3_title: '',
    contact_card3_info: '',
    contact_card3_value: '',
    contact_card3_content: '',
    office_address: '',
    office_hours: '',
    insta_id1: '',
    insta_id1_info: '',
    insta_id1_link: '',
    insta_id2: '',
    insta_id2_info: '',
    insta_id2_link: '',
    youtube_title: '',
    youtube_info: '',
    youtube_link: '',
    main_website_title: '',
    main_website_info: '',
    main_website_link: '',
    phone: '',
    email: ''
  });

  const [expandedSections, setExpandedSections] = useState({
    hero: true,
    pmp: false,
    sap: false,
    amm: false,
    mb: false,
    qs: false,
    sm: false,
    ra: false,
    contact: false
  });

  // Handle body scroll when sidebar is open on mobile
  useEffect(() => {
    if (sidebarOpen && window.innerWidth < 1024) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [sidebarOpen]);

  // Fetch existing content
  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/content');
      if (response.data.success && response.data.data) {
        setContentData(prev => ({
          ...prev,
          ...response.data.data
        }));
      }
    } catch (error) {
      console.error('Error fetching content:', error);
      toast.error('Failed to fetch content');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContentData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post('/api/content', contentData);
      if (response.data.success) {
        toast.success('Content saved successfully!');
      }
    } catch (error) {
      console.error('Error saving content:', error);
      toast.error('Failed to save content');
    } finally {
      setLoading(false);
    }
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const renderSection = (title, sectionKey, icon, fields) => (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md mb-6 overflow-hidden">
      <div 
        className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 cursor-pointer"
        onClick={() => toggleSection(sectionKey)}
      >
        <div className="flex items-center space-x-3">
          {icon}
          <h2 className="text-lg font-semibold">{title}</h2>
        </div>
        {expandedSections[sectionKey] ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>
      
      {expandedSections[sectionKey] && (
        <div className="p-4 md:p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          {fields.map((field, index) => (
            <div key={index} className="space-y-2">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                {field.label}
              </label>
              {field.type === 'textarea' ? (
                <textarea
                  name={field.name}
                  value={contentData[field.name] || ''}
                  onChange={handleInputChange}
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                  placeholder={field.placeholder}
                />
              ) : (
                <input
                  type={field.type || 'text'}
                  name={field.name}
                  value={contentData[field.name] || ''}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                  placeholder={field.placeholder}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <div className="flex h-screen">
        {/* Sidebar */}
        <Sidebar isOpen={sidebarOpen} />
        
        {/* Main Content Area */}
        <div className="flex-1 flex flex-col min-h-screen overflow-hidden lg:ml-64">
          {/* Header */}
          <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

          {/* Main Content */}
          <main className="flex-1 overflow-y-auto p-4 md:p-6">
            {/* Welcome Section */}
            <div className="mb-6 md:mb-8">
              <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white">
                Content Management
              </h1>
              <p className="text-sm md:text-base text-gray-600 dark:text-gray-400 mt-1 md:mt-2">
                Manage all content sections for your website
              </p>
            </div>

            {/* Loading State */}
            {loading && (
              <div className="text-center py-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              {/* HERO SECTION */}
              {renderSection('Hero Section', 'hero', <Globe className="w-5 h-5" />, [
                { name: 'hero_title', label: 'Hero Title', placeholder: 'Enter hero title' },
                { name: 'hero_subtitle', label: 'Hero Subtitle', type: 'textarea', placeholder: 'Enter hero subtitle' },
                { name: 'hero_button_text1', label: 'Button 1 Text', placeholder: 'Enter button 1 text' },
                { name: 'hero_button_link1', label: 'Button 1 Link', placeholder: 'Enter button 1 link' },
                { name: 'hero_button_text2', label: 'Button 2 Text', placeholder: 'Enter button 2 text' },
                { name: 'hero_button_link2', label: 'Button 2 Link', placeholder: 'Enter button 2 link' },
                { name: 'hero_card1_title', label: 'Card 1 Title', placeholder: 'Enter card 1 title' },
                { name: 'hero_card1_text', label: 'Card 1 Text', type: 'textarea', placeholder: 'Enter card 1 text' },
                { name: 'hero_card2_title', label: 'Card 2 Title', placeholder: 'Enter card 2 title' },
                { name: 'hero_card2_text', label: 'Card 2 Text', type: 'textarea', placeholder: 'Enter card 2 text' },
                { name: 'hero_card3_title', label: 'Card 3 Title', placeholder: 'Enter card 3 title' },
                { name: 'hero_card3_text', label: 'Card 3 Text', type: 'textarea', placeholder: 'Enter card 3 text' }
              ])}

              {/* PMP SECTION */}
              {renderSection('Premium Membership Portal', 'pmp', <Award className="w-5 h-5" />, [
                { name: 'pmp_card1_text', label: 'Card 1 Text', type: 'textarea', placeholder: 'Enter card 1 text' },
                { name: 'pmp_card2_text', label: 'Card 2 Text', type: 'textarea', placeholder: 'Enter card 2 text' },
                { name: 'pmp_card3_text', label: 'Card 3 Text', type: 'textarea', placeholder: 'Enter card 3 text' },
                { name: 'pmp_card4_text', label: 'Card 4 Text', type: 'textarea', placeholder: 'Enter card 4 text' },
                { name: 'pmp_left_card_title', label: 'Left Card Title', placeholder: 'Enter left card title' },
                { name: 'pmp_left_card_desc', label: 'Left Card Description', type: 'textarea', placeholder: 'Enter description' },
                { name: 'pmp_left_card_info', label: 'Left Card Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'pmp_left_card_text1', label: 'Left Card Text 1', type: 'textarea', placeholder: 'Enter text 1' },
                { name: 'pmp_left_card_text2', label: 'Left Card Text 2', type: 'textarea', placeholder: 'Enter text 2' },
                { name: 'pmp_left_card_text3', label: 'Left Card Text 3', type: 'textarea', placeholder: 'Enter text 3' },
                { name: 'pmp_left_card_text4', label: 'Left Card Text 4', type: 'textarea', placeholder: 'Enter text 4' },
                { name: 'pmp_left_card_text5', label: 'Left Card Text 5', type: 'textarea', placeholder: 'Enter text 5' },
                { name: 'pmp_right_card1_title', label: 'Right Card 1 Title', placeholder: 'Enter title' },
                { name: 'pmp_right_card1_info', label: 'Right Card 1 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'pmp_right_card2_title', label: 'Right Card 2 Title', placeholder: 'Enter title' },
                { name: 'pmp_right_card2_info', label: 'Right Card 2 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'pmp_right_card3_title', label: 'Right Card 3 Title', placeholder: 'Enter title' },
                { name: 'pmp_right_card3_info', label: 'Right Card 3 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'pmp_right_card4_title', label: 'Right Card 4 Title', placeholder: 'Enter title' },
                { name: 'pmp_right_card4_info', label: 'Right Card 4 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'pmp_importent_note_text', label: 'Important Note', type: 'textarea', placeholder: 'Enter important note' },
                { name: 'why_choose_num1', label: 'Why Choose 1 Number', placeholder: 'Enter number/stat' },
                { name: 'why_choose_text1', label: 'Why Choose 1 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'why_choose_num2', label: 'Why Choose 2 Number', placeholder: 'Enter number/stat' },
                { name: 'why_choose_text2', label: 'Why Choose 2 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'why_choose_num3', label: 'Why Choose 3 Number', placeholder: 'Enter number/stat' },
                { name: 'why_choose_text3', label: 'Why Choose 3 Text', type: 'textarea', placeholder: 'Enter text' }
              ])}

              {/* SAP SECTION */}
              {renderSection('Secure Access Portal', 'sap', <Shield className="w-5 h-5" />, [
                { name: 'sap_left_card_title_main', label: 'Main Title', placeholder: 'Enter main title' },
                { name: 'sap_left_card_title1', label: 'Title 1', placeholder: 'Enter title 1' },
                { name: 'sap_left_card_info1', label: 'Info 1', type: 'textarea', placeholder: 'Enter info 1' },
                { name: 'sap_left_card_title2', label: 'Title 2', placeholder: 'Enter title 2' },
                { name: 'sap_left_card_info2', label: 'Info 2', type: 'textarea', placeholder: 'Enter info 2' },
                { name: 'sap_left_card_title3', label: 'Title 3', placeholder: 'Enter title 3' },
                { name: 'sap_left_card_info3', label: 'Info 3', type: 'textarea', placeholder: 'Enter info 3' }
              ])}

              {/* AMM SECTION */}
              {renderSection('About Market Maestroo', 'amm', <Users className="w-5 h-5" />, [
                { name: 'amm_card1_title', label: 'Card 1 Title', placeholder: 'Enter title' },
                { name: 'amm_card1_text', label: 'Card 1 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_card2_title', label: 'Card 2 Title', placeholder: 'Enter title' },
                { name: 'amm_card2_text', label: 'Card 2 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_card3_title', label: 'Card 3 Title', placeholder: 'Enter title' },
                { name: 'amm_card3_text', label: 'Card 3 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_card4_title', label: 'Card 4 Title', placeholder: 'Enter title' },
                { name: 'amm_card4_text', label: 'Card 4 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_left_card_title', label: 'Left Card Title', placeholder: 'Enter title' },
                { name: 'amm_our_mission_text', label: 'Our Mission Text', type: 'textarea', placeholder: 'Enter mission text' },
                { name: 'amm_left_card_rd_text1', label: 'RD Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_left_card_rd_text2', label: 'RD Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_left_card_rd_text3', label: 'RD Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_left_card_rd_text4', label: 'RD Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_left_card_rd_text5', label: 'RD Text 5', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_right_card_title', label: 'Right Card Title', placeholder: 'Enter title' },
                { name: 'amm_right_card_text1', label: 'Right Card Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_right_card_text2', label: 'Right Card Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_right_card_text3', label: 'Right Card Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_right_card_text4', label: 'Right Card Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_right_card_text5', label: 'Right Card Text 5', type: 'textarea', placeholder: 'Enter text' },
                { name: 'amm_right_card_dr_text1', label: 'DR Text 1', placeholder: 'Enter text' },
                { name: 'amm_right_card_dr_link1', label: 'DR Link 1', placeholder: 'Enter link' },
                { name: 'amm_right_card_dr_text2', label: 'DR Text 2', placeholder: 'Enter text' },
                { name: 'amm_right_card_dr_link2', label: 'DR Link 2', placeholder: 'Enter link' }
              ])}

              {/* MEMBER BENEFITS */}
              {renderSection('Member Benefits', 'mb', <BarChart3 className="w-5 h-5" />, [
                { name: 'mb_card1_title', label: 'Card 1 Title', placeholder: 'Enter title' },
                { name: 'mb_card1_text1', label: 'Card 1 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card1_text2', label: 'Card 1 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card1_text3', label: 'Card 1 Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card1_text4', label: 'Card 1 Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card2_title', label: 'Card 2 Title', placeholder: 'Enter title' },
                { name: 'mb_card2_text1', label: 'Card 2 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card2_text2', label: 'Card 2 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card2_text3', label: 'Card 2 Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card2_text4', label: 'Card 2 Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card3_title', label: 'Card 3 Title', placeholder: 'Enter title' },
                { name: 'mb_card3_text1', label: 'Card 3 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card3_text2', label: 'Card 3 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card3_text3', label: 'Card 3 Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card3_text4', label: 'Card 3 Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card4_title', label: 'Card 4 Title', placeholder: 'Enter title' },
                { name: 'mb_card4_text1', label: 'Card 4 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card4_text2', label: 'Card 4 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card4_text3', label: 'Card 4 Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card4_text4', label: 'Card 4 Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card5_title', label: 'Card 5 Title', placeholder: 'Enter title' },
                { name: 'mb_card5_text1', label: 'Card 5 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card5_text2', label: 'Card 5 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card5_text3', label: 'Card 5 Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card5_text4', label: 'Card 5 Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card6_title', label: 'Card 6 Title', placeholder: 'Enter title' },
                { name: 'mb_card6_text1', label: 'Card 6 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card6_text2', label: 'Card 6 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card6_text3', label: 'Card 6 Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_card6_text4', label: 'Card 6 Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_pa_title', label: 'PA Title', placeholder: 'Enter title' },
                { name: 'mb_pa_text1', label: 'PA Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_pa_text2', label: 'PA Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_pa_text3', label: 'PA Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'mb_pa_info', label: 'PA Info', type: 'textarea', placeholder: 'Enter info' }
              ])}

              {/* QUICK START */}
              {renderSection('Quick Start', 'qs', <PieChart className="w-5 h-5" />, [
                { name: 'qs_card1_title', label: 'Card 1 Title', placeholder: 'Enter title' },
                { name: 'qs_card1_text', label: 'Card 1 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_card2_title', label: 'Card 2 Title', placeholder: 'Enter title' },
                { name: 'qs_card2_text', label: 'Card 2 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_card3_title', label: 'Card 3 Title', placeholder: 'Enter title' },
                { name: 'qs_card3_text', label: 'Card 3 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_card4_title', label: 'Card 4 Title', placeholder: 'Enter title' },
                { name: 'qs_card4_text', label: 'Card 4 Text', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card1_title', label: 'Main Card 1 Title', placeholder: 'Enter title' },
                { name: 'qs_main_card1_info', label: 'Main Card 1 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'qs_main_card1_text1', label: 'Main Card 1 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card1_text2', label: 'Main Card 1 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card1_text3', label: 'Main Card 1 Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card2_title', label: 'Main Card 2 Title', placeholder: 'Enter title' },
                { name: 'qs_main_card2_info', label: 'Main Card 2 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'qs_main_card2_text1', label: 'Main Card 2 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card2_text2', label: 'Main Card 2 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card2_text3', label: 'Main Card 2 Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card3_title', label: 'Main Card 3 Title', placeholder: 'Enter title' },
                { name: 'qs_main_card3_info', label: 'Main Card 3 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'qs_main_card3_text1', label: 'Main Card 3 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card3_text2', label: 'Main Card 3 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card3_text3', label: 'Main Card 3 Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card4_title', label: 'Main Card 4 Title', placeholder: 'Enter title' },
                { name: 'qs_main_card4_info', label: 'Main Card 4 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'qs_main_card4_text1', label: 'Main Card 4 Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card4_text2', label: 'Main Card 4 Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'qs_main_card4_text3', label: 'Main Card 4 Text 3', type: 'textarea', placeholder: 'Enter text' }
              ])}

              {/* SECURITY MATTERS */}
              {renderSection('Security Matters', 'sm', <Shield className="w-5 h-5" />, [
                { name: 'sm_card1_title', label: 'Card 1 Title', placeholder: 'Enter title' },
                { name: 'sm_card1_info', label: 'Card 1 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'sm_card2_title', label: 'Card 2 Title', placeholder: 'Enter title' },
                { name: 'sm_card2_info', label: 'Card 2 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'sm_card3_title', label: 'Card 3 Title', placeholder: 'Enter title' },
                { name: 'sm_card3_info', label: 'Card 3 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'sm_card4_title', label: 'Card 4 Title', placeholder: 'Enter title' },
                { name: 'sm_card4_info', label: 'Card 4 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'sm_pp_text1', label: 'PP Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'sm_pp_text2', label: 'PP Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'sm_pp_text3', label: 'PP Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'sm_pp_text4', label: 'PP Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'sm_is_text1', label: 'IS Text 1', type: 'textarea', placeholder: 'Enter text' },
                { name: 'sm_is_text2', label: 'IS Text 2', type: 'textarea', placeholder: 'Enter text' },
                { name: 'sm_is_text3', label: 'IS Text 3', type: 'textarea', placeholder: 'Enter text' },
                { name: 'sm_is_text4', label: 'IS Text 4', type: 'textarea', placeholder: 'Enter text' },
                { name: 'sm_256_bit_info', label: '256-bit Info', type: 'textarea', placeholder: 'Enter 256-bit security info' }
              ])}

              {/* REGULATORY COMPLIANCE */}
              {renderSection('Regulatory Compliance', 'ra', <FileText className="w-5 h-5" />, [
                { name: 'ra_left_card_title_main', label: 'Left Card Main Title', placeholder: 'Enter main title' },
                { name: 'ra_left_card_info_main', label: 'Left Card Main Info', type: 'textarea', placeholder: 'Enter main info' },
                { name: 'ra_left_card_title1', label: 'Left Card Title 1', placeholder: 'Enter title 1' },
                { name: 'ra_left_card_content1', label: 'Left Card Content 1', type: 'textarea', placeholder: 'Enter content 1' },
                { name: 'ra_left_card_title2', label: 'Left Card Title 2', placeholder: 'Enter title 2' },
                { name: 'ra_left_card_content2', label: 'Left Card Content 2', type: 'textarea', placeholder: 'Enter content 2' },
                { name: 'ra_rd_title', label: 'RD Title', placeholder: 'Enter RD title' },
                { name: 'ra_rd_info', label: 'RD Info', type: 'textarea', placeholder: 'Enter RD info' },
                { name: 'ra_dr_title1', label: 'DR Title 1', placeholder: 'Enter DR title 1' },
                { name: 'ra_dr_content1', label: 'DR Content 1', type: 'textarea', placeholder: 'Enter DR content 1' },
                { name: 'ra_dr_title2', label: 'DR Title 2', placeholder: 'Enter DR title 2' },
                { name: 'ra_dr_content2', label: 'DR Content 2', type: 'textarea', placeholder: 'Enter DR content 2' },
                { name: 'ra_tag1', label: 'Tag 1', placeholder: 'Enter tag 1' },
                { name: 'ra_tag2', label: 'Tag 2', placeholder: 'Enter tag 2' },
                { name: 'ra_tag3', label: 'Tag 3', placeholder: 'Enter tag 3' },
                { name: 'ra_tag4', label: 'Tag 4', placeholder: 'Enter tag 4' }
              ])}

              {/* CONTACT SECTION */}
              {renderSection('Contact Information', 'contact', <Phone className="w-5 h-5" />, [
                { name: 'contact_card1_title', label: 'Contact Card 1 Title', placeholder: 'Enter title' },
                { name: 'contact_card1_info', label: 'Contact Card 1 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'contact_card1_value', label: 'Contact Card 1 Value', placeholder: 'Enter value' },
                { name: 'contact_card1_content', label: 'Contact Card 1 Content', type: 'textarea', placeholder: 'Enter content' },
                { name: 'contact_card2_title', label: 'Contact Card 2 Title', placeholder: 'Enter title' },
                { name: 'contact_card2_info', label: 'Contact Card 2 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'contact_card2_value', label: 'Contact Card 2 Value', placeholder: 'Enter value' },
                { name: 'contact_card2_content', label: 'Contact Card 2 Content', type: 'textarea', placeholder: 'Enter content' },
                { name: 'contact_card3_title', label: 'Contact Card 3 Title', placeholder: 'Enter title' },
                { name: 'contact_card3_info', label: 'Contact Card 3 Info', type: 'textarea', placeholder: 'Enter info' },
                { name: 'contact_card3_value', label: 'Contact Card 3 Value', placeholder: 'Enter value' },
                { name: 'contact_card3_content', label: 'Contact Card 3 Content', type: 'textarea', placeholder: 'Enter content' },
                { name: 'office_address', label: 'Office Address', type: 'textarea', placeholder: 'Enter office address' },
                { name: 'office_hours', label: 'Office Hours', type: 'textarea', placeholder: 'Enter office hours' },
                { name: 'insta_id1', label: 'Instagram ID 1', placeholder: 'Enter Instagram ID' },
                { name: 'insta_id1_info', label: 'Instagram Info 1', type: 'textarea', placeholder: 'Enter Instagram info' },
                { name: 'insta_id1_link', label: 'Instagram Link 1', placeholder: 'Enter Instagram link' },
                { name: 'insta_id2', label: 'Instagram ID 2', placeholder: 'Enter Instagram ID' },
                { name: 'insta_id2_info', label: 'Instagram Info 2', type: 'textarea', placeholder: 'Enter Instagram info' },
                { name: 'insta_id2_link', label: 'Instagram Link 2', placeholder: 'Enter Instagram link' },
                { name: 'youtube_title', label: 'YouTube Title', placeholder: 'Enter YouTube title' },
                { name: 'youtube_info', label: 'YouTube Info', type: 'textarea', placeholder: 'Enter YouTube info' },
                { name: 'youtube_link', label: 'YouTube Link', placeholder: 'Enter YouTube link' },
                { name: 'main_website_title', label: 'Main Website Title', placeholder: 'Enter website title' },
                { name: 'main_website_info', label: 'Main Website Info', type: 'textarea', placeholder: 'Enter website info' },
                { name: 'main_website_link', label: 'Main Website Link', placeholder: 'Enter website link' },
                { name: 'phone', label: 'Phone Number', placeholder: 'Enter phone number' },
                { name: 'email', label: 'Email Address', type: 'email', placeholder: 'Enter email address' }
              ])}

              {/* Submit Button */}
              <div className="fixed bottom-0 left-0 right-0 lg:left-64 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 p-4 shadow-lg">
                <div className="max-w-7xl mx-auto flex justify-between items-center">
                  <div>
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                      {loading ? 'Saving...' : 'Make sure to save all changes'}
                    </p>
                  </div>
                  <div className="flex space-x-3">
                    <button
                      type="button"
                      onClick={() => window.location.reload()}
                      className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
                    >
                      <X className="inline w-4 h-4 mr-2" />
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={loading}
                      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                    >
                      <Save className="inline w-4 h-4 mr-2" />
                      {loading ? 'Saving...' : 'Save All Changes'}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ContentManagement;